/** Ops Hosting is a standalone ITSM product, not Communio Social or Paydirt. */
export function isOpsItsmBuild(
  flag: string | undefined = process.env.NEXT_PUBLIC_COMMUNIO_OPS,
): boolean {
  return flag === 'true';
}
